import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import '@/ui/NumberEditModal/NumberEditModal.scss';
import { Style } from '@components/style';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const { alertColor } = new Style().getUiConfig();

function NumberEditModal({
  keyObject,
  itemCount: beforeItemCount,
  limitCount = '99',
  plus,
  minus,
}) {
  const intl = useIntl();
  const [isVaild, setIsVaild] = useState(true);
  const [itemCount, setItemCount] = useState('');

  useEffect(() => {
    setItemCount('');
  }, []);

  const handleNumberChange = (e) => {
    setItemCount(e.target.value);

    if (Number(e.target.value) > Number(limitCount)) {
      setIsVaild(false);
      return;
    }
    setIsVaild(true);
  };

  const confirmClick = () => {
    if (beforeItemCount < itemCount) {
      for (let i = 0; i < Number(itemCount) - Number(beforeItemCount); i += 1) {
        plus();
      }
    } else if (beforeItemCount > itemCount) {
      for (let i = 0; i < Number(beforeItemCount) - Number(itemCount); i += 1) {
        minus();
      }
    }
    setItemCount('');
  };

  const cancelClick = () => {
    setItemCount('');
    setIsVaild(true);
  };

  return (
    <div
      className="modal number-edit-modal-backdrop"
      id={`numberEditModalBackDrop-${keyObject.id}`}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
          style={{ borderRadius: '10px 10px 10px 10px', maxHeight: '250px' }}
        >
          <div className="modal-header">
            <h5
              className="modal-title"
              id="numberEditModalBackDropLabel"
              style={{ color: '#58B6A8' }}
            >
              <strong>
                <FormattedMessage id="number.edit" />
              </strong>
            </h5>
          </div>
          <div className="modal-body">
            <input
              className="no-spinner"
              id="input-number"
              min="0"
              step="1"
              type="number"
              style={{
                border: '1px solid #8D8C8C',
                color: '#8D8C8C',
                borderRadius: '10px 10px 10px 10px',
                fontSize: '16px',
                width: '100%',
                minHeight: '40px',
                marginTop: '6px',
                paddingLeft: '10px',
              }}
              placeholder={intl.formatMessage({
                id: 'number.edit.placeholder',
              })}
              onChange={handleNumberChange}
              value={itemCount}
            />
            {!isVaild && (
              <div
                className="d-flex gap-1 align-items-center"
                style={{ color: alertColor, fontSize: '12px' }}
              >
                <Warn style={{ marginRight: '5px' }} />
                <FormattedMessage
                  id="number.edit.warning"
                  values={{ count: limitCount }}
                />
              </div>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            <button
              type="button"
              className="btn-lg"
              data-bs-dismiss="modal"
              style={{
                fontSize: '16px',
                minWidth: '100px',
                border: '1px solid #5292D9',
                backgroundColor: '#FFF',
                borderRadius: '10px',
                color: '#5292D9',
                minHeight: '46px',
              }}
              aria-label="cancelClick"
              onClick={cancelClick}
            >
              <strong>
                <FormattedMessage id="common.cancel" />
              </strong>
            </button>
            <button
              type="button"
              className="btn-lg"
              data-bs-dismiss="modal"
              style={{
                fontSize: '16px',
                minWidth: '100px',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#5292D9',
                color: '#FFF',
                minHeight: '46px',
                opacity: itemCount === '' || !isVaild ? 0.5 : 1, // 加上視覺提示
                cursor:
                  itemCount === '' || !isVaild ? 'not-allowed' : 'pointer',
              }}
              aria-label="confirmClick"
              disabled={itemCount === '' || !isVaild}
              onClick={confirmClick}
            >
              <strong>
                <FormattedMessage id="common.confirm" />
              </strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

NumberEditModal.defaultProps = {
  limitCount: '99',
  plus: () => {},
  minus: () => {},
};

NumberEditModal.propTypes = {
  keyObject: PropTypes.any,
  itemCount: PropTypes.any,
  limitCount: PropTypes.string,
  plus: PropTypes.func,
  minus: PropTypes.func,
};

export default NumberEditModal;
